import * as types from '../../mutation-types.js';
import http from '@service/http';
import util from '@common/utils/util';
import { tokenCall,restCall } from '@service/adapter';
import Constant from '@/Constant';
/**
 * 客户订单STORE
 */
export default {
  state: {
  },
  actions: {
    //获取用户售后服务验证码
    getCustomerCode({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/mem/sendSmsCode',data,'get').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //用户验证码登录
    userLoginByCode({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/mem/login',data,'post').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //获取order订单信息
    getSaleOrderInfo({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/sale/getOrderInfo',data,'get').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //售后列表
    getSalePageOrder({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/sale/pageOrder',data,'post').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //售后投诉列表
    getPageComplaintOrder({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/sale/pageComplaintOrder ',data,'post').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //修改客户信息/sale/updateSaleOrder
    updateSaleOrderInfo({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/sale/updateSaleOrder',data,'post').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    
    //售后详情
    getSaleOrderById({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/sale/getOrderById',data,'get').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //安装师傅提交安装结果
    updateOrderResult({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/sale/updateOrderResult',data,'post').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //经销商处理投诉结果 
    dealerComplaint({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/sale/dealerComplaint',data,'post').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //客户投诉 
    createComplaint({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/sale/createComplaint ',data,'post').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },
    //客户对处理意见的投诉
    updateComplaintScore({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxoa/sale/updateComplaintScore ',data,'post').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },
  },
  mutations: {
  },
  getters: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/customerService/index.js